export default __webpack_public_path__ + "a323455fa49197b9f822537e855e2cf7.png";